import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import styles from "./adminverificationsuccess.module.css";
import { APP_LINK_login } from "../../CONSTANTS";

function AdminVerificationSuccess({ message }) {
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");
    const isCustomer = type === "customer";
    return (
        <div className={[styles.success_container, "box-container"].join(" ")}>
            <div>
                <FaCheckCircle
                    color="#28a745"
                    style={{ height: "100px", width: "100px" }}
                />
            </div>
            <div className={styles.success_title}>
                <span>Email Verified Successfully</span>
            </div>
            {!isCustomer && (
                <div className={styles.success_message}>
                    <p>{message || "Your admin email has been verified successfully."}</p>
                </div>
            )}
            {isCustomer && (
                <a href={APP_LINK_login} className={styles.login_button}>
                    Login to Account
                </a>
            )}
        </div>
    );
}

export default AdminVerificationSuccess; 